import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

// Importación de componentes
import Info from "./Profile/InfoProfile";
import Resume from "./Resume/Resume";
import Portfolio from "./Portfolio/Portfolio";
import Contact from "./Contact/Contact";
import AreasOfExpertise from "./Interests/Interests"; 
import NavBar from "./GeneralSubcomponents/NavBar";
import NotFound from "./GeneralSubcomponents/NotFound";
import SEO from "./GeneralSubcomponents/SEO";
import "../Styles/cardCont.css";

const CardCont = () => (
  <Router>
    <div className="container o-cont">
      <div className="card o-card">
        {/* Barra de navegación */}
        <NavBar />

        <Switch>
          {/* Ruta principal */}
          <Route exact path="/">
            <div className="row">
              <Info />
              <SEO
                title="Profile"
                description="Learn more about Laura, her background and interests."
                name="Laura's Profile"
                type="article"
              />
            </div>
          </Route>

          {/* Ruta del resumen */}
          <Route path="/resume">
            <div className="row">
              <Resume />
              <SEO
                title="Resume"
                description="Explore Laura's resume, experience, and career milestones."
                name="Laura's Resume"
                type="resume"
              />
            </div>
          </Route>

          {/* Ruta de Areas of Expertise */}
          <Route path="/areas-of-expertise">
            <div className="row">
              <AreasOfExpertise />
              <SEO
                title="Areas of Expertise"
                description="Explore the areas Laura specializes in and where she is focusing her career."
                name="Laura's Areas of Expertise"
                type="article"
              />
            </div>
          </Route>

          {/* Ruta del portfolio */}
          <Route path="/portfolio">
            <div className="row">
              <Portfolio />
              <SEO
                title="Portfolio"
                description="Check out Laura's portfolio, showcasing her work and projects."
                name="Laura's Portfolio"
                type="portfolio"
              />
            </div>
          </Route>

          {/* Ruta de contacto */}
          <Route path="/contact">
            <div className="row">
              <Contact />
              <SEO
                title="Contact"
                description="Get in touch with Laura for collaborations or inquiries."
                name="Laura's Contact"
                type="contact"
              />
            </div>
          </Route>

          {/* Ruta de Not Found */}
          <Route path="*">
            <NotFound />
          </Route>
        </Switch>
      </div>
    </div>
  </Router>
);

export default CardCont;
